import * as React from "react";
interface iconProps {
  width?: string | number;
  height?: string | number;
}
const CovidIcon = ({ width, height }: iconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_841_8100"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={18}
      height={19}
    >
      <path
        d="M14.3802 0.962891H3.29617C1.73456 0.962891 0.468628 2.31889 0.468628 3.99161V15.8642C0.468628 17.5369 1.73456 18.8929 3.29617 18.8929H14.3802C15.9418 18.8929 17.2077 17.5369 17.2077 15.8642V3.99161C17.2077 2.31889 15.9418 0.962891 14.3802 0.962891Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_841_8100)">
      <path
        d="M14.3802 0.962891H3.29617C1.73456 0.962891 0.468628 2.31889 0.468628 3.99161V15.8642C0.468628 17.5369 1.73456 18.8929 3.29617 18.8929H14.3802C15.9418 18.8929 17.2077 17.5369 17.2077 15.8642V3.99161C17.2077 2.31889 15.9418 0.962891 14.3802 0.962891Z"
        fill="url(#paint0_linear_841_8100)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.95056 0.962891H14.4926C16.0542 0.962891 17.3201 2.31889 17.3201 3.99161V15.8642C17.3201 17.5369 16.0542 18.8929 14.4926 18.8929H8.95056V0.962891Z"
        fill="url(#paint1_radial_841_8100)"
      />
    </g>
    <path
      d="M12.701 10.4209V9.58301C12.701 8.48565 12.2941 7.43312 11.5696 6.65723C10.8452 5.88122 9.86264 5.44531 8.83817 5.44531C7.81371 5.44531 6.83109 5.88122 6.10673 6.65723C5.38227 7.43317 4.97531 8.48565 4.97531 9.58301V10.4209C4.77518 10.5575 4.65382 10.7941 4.65344 11.0484V11.7955C4.65344 11.9936 4.72692 12.1836 4.8577 12.3238C4.98855 12.4638 5.16595 12.5426 5.3509 12.5426C5.3509 12.7407 5.42438 12.9307 5.55516 13.0708C5.68601 13.2109 5.86341 13.2896 6.04836 13.2896H6.39709C6.5358 13.2896 6.66892 13.2306 6.76698 13.1255C6.86504 13.0205 6.92017 12.8779 6.92017 12.7293V10.1146C6.92017 9.96597 6.86506 9.82338 6.76698 9.71835C6.6689 9.61331 6.53578 9.55425 6.39709 9.55425H6.04836C5.86341 9.55425 5.686 9.63296 5.55516 9.77304C5.42438 9.9132 5.3509 10.1032 5.3509 10.3013C5.34164 10.3013 5.33346 10.3039 5.32404 10.3043V9.58302C5.32412 8.86945 5.51491 8.17082 5.874 7.56983L6.17144 7.88868C6.20748 7.92795 6.25808 7.9478 6.30922 7.9428C6.36036 7.9383 6.40706 7.90978 6.43688 7.86492C6.9901 7.0328 7.8845 6.53828 8.83813 6.53719C9.62036 6.53436 10.371 6.86761 10.9219 7.46246C11.0385 7.58628 11.1448 7.72093 11.2393 7.86477C11.269 7.9098 11.3156 7.93848 11.3667 7.94323H11.3815H11.3816C11.4278 7.94323 11.4722 7.92356 11.5049 7.88845L11.8023 7.56986C12.1614 8.17085 12.3522 8.8695 12.3523 9.58304V10.3044C12.3433 10.3044 12.3348 10.3014 12.3254 10.3014C12.3254 10.1033 12.2519 9.91322 12.1212 9.77307C11.9903 9.63299 11.8129 9.55428 11.628 9.55428H11.2792C11.1405 9.55428 11.0074 9.61331 10.9093 9.71837C10.8113 9.82343 10.7562 9.96602 10.7562 10.1146V12.7294C10.7565 12.8755 10.81 13.0158 10.9055 13.1202C11.0009 13.2246 11.1307 13.2849 11.267 13.2883C11.2287 13.4486 11.1419 13.5906 11.02 13.6922C10.8982 13.7939 10.7484 13.8494 10.594 13.85H10.0587C10.0587 13.7014 10.0036 13.5588 9.90551 13.4538C9.80743 13.3487 9.67431 13.2897 9.53562 13.2897H9.18689C8.99999 13.2897 8.82734 13.3965 8.73386 13.5698C8.64045 13.7432 8.64045 13.9568 8.73386 14.1302C8.82735 14.3035 8.99999 14.4103 9.18689 14.4103H9.53562C9.68359 14.4098 9.82433 14.3419 9.92273 14.2235H10.594C10.8411 14.2233 11.0801 14.1293 11.2687 13.9585C11.4573 13.7876 11.5833 13.5506 11.6245 13.2897H11.628C11.8129 13.2897 11.9903 13.211 12.1212 13.0709C12.252 12.9307 12.3254 12.7407 12.3254 12.5426C12.5104 12.5426 12.6878 12.4639 12.8187 12.3238C12.9494 12.1837 13.0229 11.9936 13.0229 11.7955V11.0485C13.0225 10.7941 12.9012 10.5576 12.701 10.4209V10.4209ZM5.35082 12.169C5.25835 12.169 5.16961 12.1297 5.10422 12.0596C5.03883 11.9896 5.00209 11.8945 5.00209 11.7955V11.0484C5.00209 10.9493 5.03883 10.8543 5.10422 10.7842C5.16961 10.7142 5.25835 10.6749 5.35082 10.6749V12.169ZM12.6741 11.7955C12.6741 11.8945 12.6374 11.9896 12.572 12.0596C12.5066 12.1297 12.4179 12.169 12.3254 12.169V10.6749C12.4179 10.6749 12.5066 10.7142 12.572 10.7842C12.6374 10.8543 12.6741 10.9493 12.6741 11.0484V11.7955Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_841_8100"
        x1={8.83817}
        y1={0.96289}
        x2={3.70278}
        y2={19.1633}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#027863" />
        <stop offset={1} stopColor="#163E36" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_841_8100"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(15.5228 0.962891) rotate(109.533) scale(19.8943 16.7719)"
      >
        <stop stopColor="#00E6BC" />
        <stop offset={1} stopColor="#01715D" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);
export { CovidIcon };
